<div class="ts-site">
  <header class="ts-site-header" [class.is-open]="menuOpen">
    <div class="ts-site-header__inner">
      <a class="ts-logo" [routerLink]="['/']">
        <span class="ts-logo__mark" aria-hidden="true">T</span>
        <span class="ts-logo__wordmark">Talespinner</span>
      </a>

      <nav class="ts-site-nav" id="ts-site-nav" aria-label="Main">
        <a [routerLink]="['/features']" routerLinkActive="is-active">Features</a>
        <a [routerLink]="['/pricing']" routerLinkActive="is-active">Pricing</a>
        <a [routerLink]="['/discover']" routerLinkActive="is-active">Discover books</a>
        <a [routerLink]="['/about']" routerLinkActive="is-active">About</a>
      </nav>

      <div class="ts-site-header__actions">
        <a class="ts-site-header__discord" href="https://discord.gg/mFyF3ePqMF" target="_blank" rel="noopener"
           aria-label="Join our Discord" title="Join our Discord">
          <app-discord-icon></app-discord-icon>
        </a>
        @if (userIsLoggedIn) {
          <a class="ts-btn ts-btn--secondary ts-btn--sm" [routerLink]="['/dashboard']">Open dashboard</a>
        } @else {
          <a class="ts-site-header__login" [routerLink]="['/account/auth/login']" routerLinkActive="is-active">Log in</a>
          <a class="ts-btn ts-btn--secondary ts-btn--sm" [routerLink]="['/account/auth/signup']">Start writing</a>
        }
      </div>

      <button type="button" class="ts-site-header__toggle"
              [attr.aria-expanded]="menuOpen" aria-controls="ts-site-menu"
              (click)="menuOpen = !menuOpen">
        <span class="ts-site-header__toggle-label">{{ menuOpen ? 'Close' : 'Menu' }}</span>
        <span class="ts-site-header__toggle-icon" aria-hidden="true"></span>
      </button>
    </div>

    <!-- Small screens: the same links, stacked -->
    <nav class="ts-site-menu" id="ts-site-menu" aria-label="Main" [attr.hidden]="menuOpen ? null : ''">
      <a [routerLink]="['/features']" routerLinkActive="is-active">Features</a>
      <a [routerLink]="['/pricing']" routerLinkActive="is-active">Pricing</a>
      <a [routerLink]="['/discover']" routerLinkActive="is-active">Discover books</a>
      <a [routerLink]="['/about']" routerLinkActive="is-active">About</a>
      <a href="https://discord.gg/mFyF3ePqMF" target="_blank" rel="noopener">Join our Discord</a>
      <div class="ts-site-menu__actions">
        @if (userIsLoggedIn) {
          <a class="ts-btn ts-btn--secondary" [routerLink]="['/dashboard']">Open dashboard</a>
        } @else {
          <a class="ts-btn ts-btn--ghost" [routerLink]="['/account/auth/login']">Log in</a>
          <a class="ts-btn ts-btn--secondary" [routerLink]="['/account/auth/signup']">Start writing</a>
        }
      </div>
    </nav>
  </header>

  <main class="ts-site-main" [class.ts-site-main--page]="!isHome">
    <router-outlet></router-outlet>
  </main>

  <footer class="ts-site-footer">
    <!-- The first stars of the evening -->
    <svg class="ts-site-footer__stars" viewBox="0 0 1200 120" preserveAspectRatio="xMidYMin slice" aria-hidden="true">
      <path class="ts-star" d="M140,40 l1.6,4.4 4.4,1.6 -4.4,1.6 -1.6,4.4 -1.6,-4.4 -4.4,-1.6 4.4,-1.6 Z"/>
      <circle class="ts-star ts-star--2" cx="318" cy="84" r="1.4"/>
      <path class="ts-star ts-star--3" d="M612,26 l1.1,3 3,1.1 -3,1.1 -1.1,3 -1.1,-3 -3,-1.1 3,-1.1 Z"/>
      <circle class="ts-star" cx="808" cy="66" r="1.2"/>
      <path class="ts-star ts-star--2" d="M1004,44 l1.4,3.8 3.8,1.4 -3.8,1.4 -1.4,3.8 -1.4,-3.8 -3.8,-1.4 3.8,-1.4 Z"/>
      <circle class="ts-star ts-star--3" cx="1120" cy="96" r="1"/>
      <circle class="ts-star ts-star--4" cx="452" cy="36" r="1"/>
    </svg>

    <div class="ts-site-footer__inner">
      <div class="ts-site-footer__brand">
        <a class="ts-logo" [routerLink]="['/']">
          <span class="ts-logo__mark" aria-hidden="true">T</span>
          <span class="ts-logo__wordmark">Talespinner</span>
        </a>
        <p class="ts-site-footer__tagline">An AI writing studio for storytellers.</p>
      </div>

      <nav class="ts-site-footer__cols" aria-label="Footer">
        <div class="ts-site-footer__col">
          <p class="t-meta">Product</p>
          <a [routerLink]="['/features']">Features</a>
          <a [routerLink]="['/pricing']">Pricing</a>
          <a [routerLink]="['/discover']">Discover books</a>
        </div>
        <div class="ts-site-footer__col">
          <p class="t-meta">Talespinner</p>
          <a [routerLink]="['/about']">About</a>
          <a href="https://discord.gg/mFyF3ePqMF" target="_blank" rel="noopener">Discord</a>
          <a href="mailto:contact@talespinner.io">contact&#64;talespinner.io</a>
        </div>
        <div class="ts-site-footer__col">
          <p class="t-meta">Legal</p>
          <a [routerLink]="['/privacy-policy']">Privacy policy</a>
          <a [routerLink]="['/terms-of-service']">Terms of service</a>
        </div>
      </nav>
    </div>

    <div class="ts-site-footer__base">
      <span>&copy; {{ currentYear }} Talespinner</span>
      <span>Operated by Bons AI · KVK 91727286 · BTW 067952045B01 · Raapopseweg 74, 6824DT Arnhem</span>
    </div>
  </footer>
</div>
